export enum SYSTEM_INFO_ENUM {
    COPYRIGHT = 'Copyright © 2021 广州致景信息科技有限公司',
    SYSTEM_NAME = '运维平台',
    SYSTEM_ENGLISH_NAME = 'TianGong Operations System'
}
